import type { TranslationsIndexes } from "../../types";

interface IndexableTranslation {
  language_uuid?: string;
  default: boolean;
}

interface SortableTranslation {
  language: string;
  default: boolean;
}

/**
 * Rebuilds translations_indexes from the field array order. Adapters compute it
 * on save rather than maintaining it while editing, so the indexes can never
 * drift from the translations they point at.
 */
export function buildTranslationsIndexes(
  formTranslations: IndexableTranslation[],
): TranslationsIndexes {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const language_uuid: Record<string, number[]> = {};
  let defaultIndex = 0;

  formTranslations.forEach((field, index) => {
    if (field.language_uuid) {
      language_uuid[field.language_uuid] = [index];
    }
    if (field.default) {
      defaultIndex = index;
    }
  });

  return {
    language_uuid,
    default: { true: [defaultIndex] },
  };
}

/**
 * Tab order: the default language first, then alphabetically by language code.
 * The data is sorted rather than the tab rendering, so that
 * activeLanguageIndex addresses the same entry in both.
 */
export function compareTranslationsByDefaultThenLanguage(
  a: SortableTranslation,
  b: SortableTranslation,
): number {
  if (a.default) return -1;
  if (b.default) return 1;

  return a.language.localeCompare(b.language);
}
